<template>
  <div>

    <div class="container breadcrumbs hidden-md hidden-sm">
      <a class="breadcrumb-item" :href="siteUrl('')" rel="nofollow">{{ $t('Kodobi') }}</a>
      <span class="divider">/</span>
      <a class="breadcrumb-item" :href="siteUrl($t('shops'))" rel="nofollow">{{ $t('Магазины') }}</a>
      <span class="divider">/</span>
      <span class="breadcrumb-item active">{{ shop.name }}</span>
    </div>

    <main class="container">

      <aside>
        <div>
          <shop-logo :shop="shop"></shop-logo>
          <noindex><shop-rating :shop="shop"></shop-rating></noindex>
        </div>

        <noindex><div class="offers-active">{{ $t('Предложений активно') }}:&nbsp;<span class="offers-count">{{ shop.coupons_count }}</span></div></noindex>
        <shop-how></shop-how>
        <noindex><shop-email-subscribe v-if="!['br', 'au'].includes(currentLocale.locale)"></shop-email-subscribe></noindex>
        <shop-popular-aside></shop-popular-aside>
        <div :class="stickyElementStyles" ref="stickyElement">
          <div v-if="shop.partner_link !== null" id="content_rb_11883" class="content_rb" data-id="11883"></div>
          <div v-else id="content_rb_11884" class="content_rb" data-id="11884"></div>
        </div>
      </aside>

      <div class="main-content">

        <div class="shop">
          <div class="shop-info hidden-lg hidden-sm">
            <shop-logo :shop="shop"></shop-logo>
            <shop-rating :shop="shop"></shop-rating>
          </div>
          <div>
            <div class="shop-info">
              <shop-logo class="hidden-lg hidden-md" :shop="shop"></shop-logo>
              <div class="shop-heading-wrapper">
                <h1 class="shop-heading">{{ shop.h1 }}</h1>
                <shop-rating class="hidden-lg hidden-md" :shop="shop"></shop-rating>
              </div>
            </div>
          </div>
        </div>

        <shop-coupons-filter :selected-type.sync="couponsType" v-if="false"></shop-coupons-filter>
        <div class="coupons">
          <div v-if="shop.partner_link !== null" id="content_rb_19947" class="content_rb" data-id="19947"></div>
          <div v-else id="content_rb_19948" class="content_rb" data-id="19948"></div>
          <div v-for="(coupon, index) in shopCoupons" :key="coupon.coupon_id">
            <div v-if="index === 2">
              <div v-if="shop.partner_link !== null" id="content_rb_15132" class="content_rb" data-id="15132"></div>
              <div v-else id="content_rb_11878" class="content_rb" data-id="11878"></div>
            </div>
            <div v-if="index === 6">
              <div v-if="shop.partner_link !== null" id="content_rb_11879" class="content_rb" data-id="11879"></div>
              <div v-else id="content_rb_11880" class="content_rb" data-id="11880"></div>
            </div>
            <div v-if="index === 12">
              <div v-if="shop.partner_link !== null" id="content_rb_11881" class="content_rb" data-id="11881"></div>
              <div v-else id="content_rb_11882" class="content_rb" data-id="11882"></div>
            </div>
            <div class="coupons-heading" v-if="coupon.firstSimilarCoupon">{{ $t('Похожие купоны') }}</div>
            <shop-coupon :key="coupon.coupon_id" :coupon="coupon" :showLogo="shop.slug !== coupon.slug"></shop-coupon>
          </div>
        </div>
        <div class="center more-coupons-wrapper" v-if="shopCoupons.length !== shopCouponsCount">
          <div v-if="shop.partner_link !== null" id="content_rb_11885" class="content_rb" data-id="11885"></div>
          <div v-else id="content_rb_11886" class="content_rb" data-id="11886"></div>
          <button class="button-more-coupons button-secondary" @click="loadMore">{{ $t('Показать ещё') }}</button>
        </div>

        <div class="shop-story" v-html="shop.content"></div>

        <div class="shop-story" v-if="shop.story" v-html="shop.story"></div>

        <div class="coupons" v-if="false && shopCouponsExpired.length">
          <div class="coupons-heading">{{ $t('Используйте эти истёкшие купоны - они могут работать') }}!</div>
          <shop-coupon v-for="coupon in shopCouponsExpired" :key="coupon.coupon_id" :coupon="coupon"></shop-coupon>
        </div>

        <div class="container breadcrumbs hidden-lg">
          <a class="breadcrumb-item" :href="siteUrl('')" rel="nofollow">{{ $t('Kodobi') }}</a>
          <span class="divider">/</span>
          <a class="breadcrumb-item" :href="siteUrl($t('shops'))" rel="nofollow">{{ $t('Магазины') }}</a>
          <span class="divider">/</span>
          <span class="breadcrumb-item active">{{ shop.name }}</span>
        </div>

      </div>

    </main>

    <div v-if="shop.partner_link !== null" id="content_rb_11889" class="content_rb" data-id="11889"></div>
    <div v-else id="content_rb_11890" class="content_rb" data-id="11890"></div>

    <shop-anchors :anchors="shop.anchors"></shop-anchors>

    <div v-if="shop.partner_link !== null" id="content_rb_11887" class="content_rb" data-id="11887"></div>
    <div v-else id="content_rb_11888" class="content_rb" data-id="11888"></div>

  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from 'vuex';
import ShopAnchors from './shop/ShopAnchors.vue';
import ShopLogo from './shop/ShopLogo.vue';
import ShopRating from './shop/ShopRating.vue';
import ShopHow from './shop/ShopHow.vue';
import ShopEmailSubscribe from './shop/ShopEmailSubscribe.vue';
import ShopPopular from './shop/ShopPopular.vue';
import ShopPopularAside from './shop/ShopPopularAside.vue';
import ShopCategories from './shop/ShopCategories.vue';
import ShopCashbackOffer from './shop/ShopCashbackOffer.vue';
import ShopCouponsFilter from './shop/ShopCouponsFilter.vue';
import ShopCoupon from './shop/ShopCoupon.vue';
import ShopLanguages from './shop/ShopLanguages.vue';
import ShopCouponModal from './shop/ShopCouponModal.vue';

export default {
  name: 'app-shop',

  components: {
    ShopAnchors,
    ShopLogo,
    ShopRating,
    ShopHow,
    ShopEmailSubscribe,
    ShopPopular,
    ShopPopularAside,
    ShopCategories,
    ShopCashbackOffer,
    ShopCouponsFilter,
    ShopCoupon,
    ShopLanguages,
    ShopCouponModal
  },

  data() {
    return {
      couponsType: 'all',
      couponViwed: false,
      couponsViewed: {},
      couponsEls: [],
      scrollTimeout: null,
      modalOpen: false,
      scrollTop: 0,
      stickyElementMinimumTop: 0,
    };
  },

  computed: {
    ...mapState([
      'currentLocale',
      'categories',
      'shop',
      'shopCoupons',
      'shopCouponsCount',
      'shopCouponsExpired',
      'shopCoupon'
    ]),

    stickyElementStyles() {
      if (this.scrollTop > this.stickyElementMinimumTop) {
          return {'sticky-fixed': true};
      }
      return {};
    }
  },

  watch: {
    couponsType(type) {
      this.fetchShopCoupons({ shop: this.shop.slug, type });
    },

    shopCoupons() {
      this.setCouponEls();
    },

    shopCoupon() {
      if (!this.modalOpen && this.shopCoupon && this.shopCoupon.coupon_id) {
        this.modalOpen = true;
        this.$nextTick(() => {
          this.$modal.show(
            ShopCouponModal,
            { coupon: this.shopCoupon, currentLocale: this.currentLocale.locale, ownHost: this.shop.own_host },
            {/*events*/}
          );
        });
      }
    },
  },

  methods: {
    ...mapActions(['fetchShopCoupons', 'fetchShopCoupon']),

    loadMore() {
      this.fetchShopCoupons({
        shop: this.shop.slug,
        type: this.couponsType,
        offset: this.shopCoupons.length,
        reload: false
      });
    },

    isElementVerticallyInViewport(el, checkSize) {
      const rect = el.getBoundingClientRect();
      return (
        (checkSize ? rect.width !== 0 && rect.height !== 0 : true) &&
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      );
    },

    setCouponEls() {
      this.$nextTick(() => {
        this.couponsEls = document.querySelectorAll('.coupon');
        this.trackCoupons();

        if (this.shopCoupons[0] && !!this.shopCoupons[0].gotolink) {
          window.VWO = window.VWO || [];
          window.VWO.push(['activate', false, [2], true]);
        }
      });
    },

    trackCoupons() {
      this.couponsEls.forEach((el) => {
        const { couponId } = el.dataset;
        if (!this.couponsViewed[couponId] && this.isElementVerticallyInViewport(el, true)) {
          this.couponsViewed[couponId] = true;
          axios.post(this.eventUrl(), { store: this.shop.slug, coupon_id: couponId, event: 'viewed' });
          if (!this.couponViwed) {
            window.yaCounter44729944 && window.yaCounter44729944.reachGoal('coupon_viewport');
            this.couponViwed = true;
          }
        }
      });
    },

    handleScroll() {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => { this.trackCoupons() }, 250);

      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!this.stickyElementMinimumTop) {
        this.stickyElementMinimumTop = this.$refs.stickyElement.offsetTop;
      }
    },
  },

  mounted() {
    this.$route.query.coupon && this.fetchShopCoupon({ couponId: this.$route.query.coupon });

    this.setCouponEls();
    document.addEventListener('scroll', this.handleScroll);
  },

  asyncData({ store, route }) {
    var slug = route.params.slug || store.state.subdomain;
    return Promise.all([
      store.dispatch('fetchCategories'),
      store.dispatch('fetchShop', { slug: slug }),
      store.dispatch('fetchShopCoupons', { shop: slug }),
      store.dispatch('fetchShopCoupons', { shop: slug, type: 'expired', limit: 10 }),
      store.dispatch('fetchPopularShop', { shopSlug: slug })
    ]);
  }
};
</script>

<style>
.aside-item {
  margin-bottom: 30px;
  padding: 35px 18px;
  color: #868993;
  background-color: #ffffff;
  border-radius: 3px;
}

.aside-item-title {
  margin: 0;
  font-size: 18px;
  line-height: 30px;
  color: #666870;
  font-weight: bold;
  text-align: center;
}

.center {
  margin: 0 auto;
  text-align: center;
}
</style>

<style scoped>
.breadcrumbs {
  padding: 20px 10px;
  font-size: 13px;
  color: #a9abb4;
}

.breadcrumb-item {
  position: relative;
  margin-right: 10px;
  text-decoration: underline;
}

.breadcrumb-item.active {
  text-decoration: none;
}

.breadcrumb-item:hover {
  text-decoration: none;
}

.breadcrumb-item:active {
  color: #666870;
  text-decoration: none;
}

.breadcrumbs .divider {
  margin-right: 10px;
}

main {
  display: flex;
}

aside {
  flex-shrink: 0;
  max-width: 240px;
  width: 100%;
  margin-right: 40px;
}

.offers-active {
  margin: 25px 0 30px 0;
  font-size: 18px;
  color: #a9abb4;
}

.offers-count {
  font-size: 18px;
  color: #a9abb4;
}

.shop {
  margin: 0 0 20px;
}

.shop-heading {
  margin: 0 0 20px 0;
  font-size: 24px;
  color: #4a5056;
  font-weight: normal;
}

.coupons {
  display: flex;
  flex-direction: column;
  margin: 15px 0 0 0;
}

.more-coupons-wrapper {
  margin-top: 10px;
}

.button-more-coupons {
  margin-top: 10px;
  width: 220px;
}

.shop-story {
  font-size: 14px;
  line-height: 20px;
  margin: 15px 0;
}

.shop-story >>> h2 {
  margin: 30px 0 20px 0;
  font-size: 30px;
  font-weight: normal;
  line-height: normal;
}

.shop-story >>> p,
.shop-story >>> ul,
.shop-story >>> ol {
  margin: 15px 0;
}

.shop-story >>> ul,
.shop-story >>> ol {
  padding: 0 0 0 18px;
}

.shop-story >>> img {
  max-width: 600px;
  width: 100% !important;
  height: auto !important;
}

.coupons-heading {
  margin: 30px 0 20px 0;
  font-size: 30px;
}

.sticky-fixed {
  position: fixed;
  top: 10px;
}

@media (max-width: 1023px) {
  aside {
    display: none;
  }

  .shop {
    display: flex;
    justify-content: flex-start;
    margin: 30px 0;
  }

  .shop-info {
    display: block;
    margin: 0 30px 0 0;
    min-width: 210px;
  }

  .shop-heading {
    margin: 0 0 28px 0;
    font-weight: normal;
  }
}

@media (max-width: 767px) {
  .shop {
    flex-direction: column;
    margin: 20px 0;
  }

  .shop-info {
    display: flex;
    margin: 0;
  }

  .shop-heading-wrapper {
    margin-left: 10px;
  }

  .shop-heading {
    font-size: 20px;
    margin: 0;
    line-height: 1.2;
  }

  .shop-story {
    font-size: 12px;
    line-height: 18px;
  }

  .shop-story >>> h2 {
    font-size: 24px;
  }

  .coupons-heading {
    font-size: 24px;
  }
}
</style>
